// @ts-nocheck
import { dataURLtoFile } from "includes/documents_treat";
import formatDate from "includes/formatDate";
import genRequest from "includes/request";
import generateUUID from "includes/UUID";

class DocumentObject {
	#documentId = null;
	#name = "TempDoc-" + generateUUID();
	#docTypeId = null;
	#publishedDate = formatDate();
	#lastChanged = formatDate();
	#lastChangeAuthorId = null;
	#documentRes = null;
	#viewCount = 0;
	#urlMin = null;
	#urlMobile = null;
	#urlOrigin = null;
	#urlWeb = null;
	#isTargetDoc = false;
	#isShareable = true;

	#fileDocString = null;
	#file = null;
	#isNew = null;
	#hasChanged = null;
	#companyId = null;
	#siteId = null;
	#groupId = null;
	#employeeId = null;
	#postId = null;
	#notify = true;
	#linkType = "sites";
	#linkTo = [];
	#linkedTo = [];
	#linkedSites = [];
	#linkedGroups = [];
	#categories = [];
	#account = false;

	#addToDocsUtiles = false;

	constructor(props) {
		this.#isNew = props.isNew || false;
		this.#hasChanged = props.hasChanged || false;
		this.#documentId = props.id || props.documentId || undefined;
		this.#name = props.name ? props.name : "";
		this.#docTypeId = props.documentTypeId || props.docTypeId;
		this.#publishedDate = props.publishedDate || formatDate();
		this.#lastChanged = props.lastChanged || formatDate();
		this.#lastChangeAuthorId = props.lastChangeAuthorId;
		this.#documentRes = props.documentRes;
		this.#viewCount = props.viewCount ? props.viewCount : 0;
		this.#urlMin = props.urlMin;
		this.#urlMobile = props.urlMobile;
		this.#urlOrigin = props.urlOrigin;
		this.#urlWeb = props.urlWeb;
		this.#isTargetDoc = props.isTargetDoc ? props.isTargetDoc : false;
		this.#isShareable =
			typeof props.isShareable !== "undefined" ? props.isShareable : true;
		this.#categories = props.categories;

		this.#linkType = "sites";
		this.#companyId = props.companyId;
		this.#siteId = props.siteId;
		this.#groupId = props.groupId;
		this.#employeeId = props.employeeId || props.employeeId;
		this.#postId = props.postId;
		this.#fileDocString = props.documentFile || props.fileDocString;
		this.#file = props.file;

		this.#addToDocsUtiles = props.addToDocsUtiles;

		if (!this.#documentId) this.tempId = generateUUID();
		this.#notify = props.documentId ? false : true;
		this.#account = props.account || false;
	}

	notify() {
		if (!this.#notify) return Promise.resolve(true);
		let url = "notifications/document/" + this.#documentId;
		let data = null;
		if (this.#linkType === "groups" && this.#linkTo?.length) {
			url = "notifications/document-group";
			data = {
				message: this.#name,
				listGroupId: this.#linkTo,
				// the API reads a display name, not the account object
				author: this.#account
					? [this.#account.firstName, this.#account.lastName].filter(Boolean).join(" ")
					: "",
				newsId: this.#documentId,
			};
		}
		let req = genRequest(url, data, "post");
		return req;
	}

	fetchForEdit(file_content_type) {
		if (!this.#documentId) return Promise.resolve(true);
		let prom = Promise.allSettled([
			this.fetchFile(file_content_type),
			this.fetchLinkedGroups(),
			this.fetchLinkedSites(),
			this.fetchCategories(),
		]);
		return prom;
	}

	fetchDocUrl() {
		let req = genRequest("documents/" + this.#documentId).then((resp) => {
			this.#urlMin = resp.urlMin;
			this.#urlMobile = resp.urlMobile;
			this.#urlOrigin = resp.urlOrigin;
		});
		return req;
	}

	fetchFile(fileType) {
		let that = this;
		let req = genRequest("documents/" + this.#documentId + "/file").then(
			(resp) => {
				if (resp) {
					let file = dataURLtoFile(fileType + resp);
					that.#file = {
						data: that.#urlOrigin,
						name: that.#name,
						size: file.size,
					};
				}
			}
		);
		return req;
	}

	send(index, onProgress) {
		let that = this;
		let prom = new Promise((resolve, reject) => {
			let xhr = that
				.delete()
				.then(() => {
					return that.sendDoc(index, onProgress);
				}, reject)
				.then(() => {
					return that.unlinkDoc();
				}, reject)
				.then(() => {
					if (that.#postId) return that.linkToPost();
					return Promise.resolve(true);
				}, reject)
				.then(() => {
					return that.linkDoc();
				}, reject)
				.then(() => {
					return that.linkCategories();
				}, reject)
				.then(() => {
					resolve(that.values());
					return true;
				}, reject);
			return xhr;
		});
		return prom;
	}

	sendDoc(index, onProgress) {
		let that = this;
		let docName = this.#name;
		if (!docName || index)
			docName =
				(typeof index !== "undefined" ? "pos:" + index + "_" : "") +
				this.#name.replace(/[\W]{1,}/gi, "_") +
				"_" +
				formatDate(Date.now());
		let fileDoc = this.#fileDocString;
		if (fileDoc && fileDoc.indexOf("data:") !== -1)
			fileDoc = fileDoc.split(",")[1];

		let url, datas;
		if (this.#documentId) {
			url = `documents/${this.#documentId}`;
			datas = {
				name: docName,
				documentTypeId: this.#docTypeId,
				urlMin: null,
				urlMobile: null,
				urlOrigin: null,
				urlWeb: null,
				publishedDate: this.#publishedDate,
				isTargetDoc: this.#isTargetDoc,
				isShareable: this.#isShareable,
				lastChanged: formatDate(),
			};
		} else {
			url = "documents/from-base64";
			datas = {
				name: docName,
				fileDocString: fileDoc,
				docTypeId: this.#docTypeId,
				companyId: this.#companyId,
				siteId: this.#siteId,
				postId: this.#postId,
				publishedDate: this.#publishedDate,
				isTargetDoc: this.#isTargetDoc,
				isShareable: this.#isShareable,
			};
		}

		let req = genRequest(url, datas, this.#documentId ? "put" : "post", {
			onUploadProgress: onProgress,
		}).then((resp) => {
			if (!this.#documentId) that.#documentId = resp;
		});
		return req;
	}

	unlinkDoc() {
		let proms = [
			this.unlinkCompany(),
			this.unlinkGroups(),
			this.unlinkSites(),
		];
		return Promise.all(proms);
	}

	linkDoc() {
		if (this.#employeeId) return this.linkToEmploye();
		// Groups picked in the wizard win over the author's site, or a
		// document meant for a group is published to the whole site
		if (this.#linkType === "groups" && this.#linkTo?.length)
			return this.linkToGroups();
		if (
			this.#siteId &&
			!(this.#linkType === "sites" && this.#linkTo?.length)
		)
			return this.linkToSite();
		if (this.#groupId) return this.linkToGroup();
		if (this.#linkType === "groups" && this.#linkTo?.length)
			return this.linkToGroups();
		if (this.#linkType === "sites" && this.#linkTo?.length)
			return this.linkToSites();
		if (this.#postId) return this.linkToPost();
		return Promise.resolve();
	}

	fetchCategories() {
		if (!this.#documentId) return Promise.resolve([]);
		let that = this;
		let req = genRequest("categories/document/" + this.#documentId).then(
			(resp) => {
				if (resp?.length)
					that.#categories = resp.map((a) => ({
						...a,
						label: a.categoryName || a.name,
						value: a.id || a.categoryId,
					}));
				else that.#categories = [];
				return resp;
			},
			() => {
				that.#categories = [];
				return [];
			}
		);
		return req;
	}

	linkCategories() {
		let prom = new Promise((resolve, reject) => {
			this.unlinkCategories()
				.then(() => {
					if (!this.#categories?.length) {
						resolve(true);
						return true;
					}
					let proms = this.#categories.map((a) => {
						return this.linkCategory(a.id || a.categoryId);
					});
					return Promise.all(proms);
				}, reject)
				.then(() => {
					resolve(true);
				}, reject);
		});
		return prom;
	}

	linkCategory(catId) {
		if (!catId) return Promise.reject(false);
		return genRequest(
			"documents/link-category",
			{
				categoryId: catId,
				documentId: this.#documentId,
			},
			"post"
		);
	}

	unlinkCategories() {
		if (!this.#documentId) return Promise.resolve(true);
		let req = genRequest(
			"documents/" + this.#documentId + "/categories",
			null,
			"delete"
		);
		return req;
	}

	linkType(set_type) {
		if (set_type && set_type !== this.#linkType) this.#linkType = set_type;
		return this.#linkType;
	}

	setLinkTo(items_list, link_type, default_site_id) {
		if (link_type) this.linkType(link_type);
		if (this.#linkType === "sites") {
			this.#isTargetDoc = false;
			if (default_site_id) this.#siteId = default_site_id;
			this.#linkTo = items_list;
		} else {
			this.#linkTo = items_list;
			this.#isTargetDoc = true;
		}
		return this.#linkTo;
	}

	getLinksTo() {
		if (!(this.#linkType && this.#linkTo)) return false;
		return {
			type: this.#linkType,
			links: this.#linkTo,
			defaultSiteId: this.#siteId,
		};
	}

	linkedTo = () => this.#linkedTo;

	links() {
		if (this.#linkedSites?.length && !this.#isTargetDoc)
			return {
				type: "sites",
				links: this.#linkedSites.map((a) => a.siteId || a.id),
			};
		if (this.#linkedGroups?.length)
			return {
				type: "groups",
				links: this.#linkedGroups.map((a) => a.groupId || a.id),
			};
		return { type: "sites", links: [] };
	}

	resetLinks(companyId, siteId, employeeId, postId) {
		this.#companyId = companyId ? companyId : null;
		this.#siteId = siteId ? siteId : null;
		this.#employeeId = employeeId ? employeeId : null;
		this.#postId = postId ? postId : null;
	}

	unlinkCompany() {
		if (!this.#documentId) return Promise.resolve(true);
		let req = genRequest(
			"documents/" + this.#documentId + "/companies",
			null,
			"delete"
		);
		return req;
	}

	linkToCompany(companyId) {
		let id = this.#companyId;
		if (companyId) id = companyId;
		let xhr = genRequest(
			"documents/link-company",
			{
				documentId: this.#documentId,
				companyId: id,
			},
			"post"
		);
		return xhr;
	}

	fetchLinkedSites() {
		if (!this.#documentId) return Promise.resolve(true);
		let req = genRequest(
			"documents/" + this.#documentId + "/sites"
		).then(
			(resp) => {
				this.#linkedSites = resp?.length ? resp : [];
				if (resp?.length) this.#linkType = "sites";
			},
			() => {
				this.#linkedSites = [];
			}
		);
		return req;
	}

	linkToSites() {
		if (!this.#linkTo?.length) return Promise.resolve(true);
		let links = this.#linkTo.map((a) => ({
			siteId: a,
			documentId: this.#documentId,
		}));
		let req = genRequest("documents/link-sites", links, "post");
		return req;
	}

	linkToSite(siteId) {
		let id = this.#siteId;
		if (siteId) id = siteId;
		let xhr = genRequest(
			"documents/link-site",
			{
				documentId: this.#documentId,
				siteId: id,
			},
			"post"
		);
		return xhr;
	}

	unlinkSites() {
		if (!this.#documentId) return Promise.resolve(true);
		let req = genRequest(
			"documents/" + this.#documentId + "/sites",
			null,
			"delete"
		);
		return req;
	}

	linkedSites = () => this.#linkedSites;

	linkedGroups = () => this.#linkedGroups;

	fetchLinkedGroups() {
		if (!this.#documentId) return Promise.resolve(true);
		let url = "groups/document/" + this.#documentId;
		let req = genRequest(url).then(
			(resp) => {
				this.#linkedGroups = resp?.length ? resp : [];
				if (resp?.length) this.#linkType = "groups";
			},
			() => {
				this.#linkedGroups = [];
			}
		);
		return req;
	}

	linkToGroups() {
		if (!this.#linkTo?.length) return Promise.resolve(true);
		let links = this.#linkTo.map((a) => ({
			groupId: a,
			documentId: this.#documentId,
		}));
		let req = genRequest(
			"documents/link-groups",
			links,
			"post"
		);
		return req;
	}

	unlinkGroups() {
		if (!this.#documentId) return Promise.resolve(true);
		let req = genRequest(
			"documents/" + this.#documentId + "/groups",
			null,
			"delete"
		);
		return req;
	}

	linkToGroup(groupId) {
		let id = this.#groupId;
		if (groupId) id = groupId;
		let xhr = genRequest(
			"documents/link-group",
			{
				documentId: this.#documentId,
				groupId: id,
			},
			"post"
		);
		return xhr;
	}

	linkToEmploye(employeeId) {
		let id = this.#employeeId;
		if (employeeId) id = employeeId;
		let xhr = genRequest(
			"documents/link-employee",
			{
				documentId: this.#documentId,
				employeeId: id,
			},
			"post"
		);
		return xhr;
	}

	linkToPost(postId) {
		let id = this.#postId;
		if (postId) id = postId;
		let xhr = genRequest(
			"documents/link-post",
			{
				documentId: this.#documentId,
				postId: id,
			},
			"post"
		);
		return xhr;
	}

	delete(documentId, force) {
		let that = this;
		let id = documentId;
		if (!documentId) id = this.#documentId;
		if (
			!id ||
			(this.#documentId && !this.#isNew && !this.#hasChanged && !force)
		)
			return Promise.resolve(true);
		let xhr = genRequest(
			"documents/" + id,
			null,
			"delete"
		).then(() => {
			that.#documentId = null;
		});
		return xhr;
	}

	notification(setNotif) {
		if (typeof setNotif !== "undefined") this.#notify = setNotif;
		return this.#notify;
	}

	categories(setCategories) {
		if (typeof setCategories !== "undefined")
			this.#categories = setCategories;
		return this.#categories;
	}

	documentId(setDocId) {
		if (typeof setDocId !== "undefined") this.#documentId = setDocId;
		return this.#documentId;
	}

	documentFile(setFile) {
		if (typeof setFile !== "undefined") {
			this.#fileDocString = setFile;
			this.#hasChanged = true;
		}
		return this.#fileDocString;
	}

	file(setFile) {
		if (typeof setFile !== "undefined") this.#file = setFile;
		return this.#file;
	}

	name(setName) {
		if (typeof setName !== "undefined") this.#name = setName;
		return this.#name;
	}

	docType(setDocType) {
		if (typeof setDocType !== "undefined") this.#docTypeId = setDocType;
		return this.#docTypeId;
	}

	publishedDate(setPublishedDate) {
		if (typeof setPublishedDate !== "undefined")
			this.#publishedDate = setPublishedDate;
		return this.#publishedDate;
	}

	isDiffered = () => new Date() < new Date(this.#publishedDate);

	isShareable = (setValue) => {
		if (typeof setValue !== "undefined") this.#isShareable = setValue;
		return this.#isShareable;
	};

	lastChanged(setLastChanged) {
		if (typeof setLastChanged !== "undefined")
			this.#lastChanged = setLastChanged;
		return this.#lastChanged;
	}

	lastChangeAuthorId(setLastChangeAuthorId) {
		if (typeof setLastChangeAuthorId !== "undefined")
			this.#lastChangeAuthorId = setLastChangeAuthorId;
		return this.#lastChangeAuthorId;
	}

	documentRes(setDocumentRes) {
		if (typeof setDocumentRes !== "undefined")
			this.#documentRes = setDocumentRes;
		return this.#documentRes;
	}

	viewCount(setViewCount) {
		if (typeof setViewCount !== "undefined") this.#viewCount = setViewCount;
		return this.#viewCount;
	}

	urls(setUrls) {
		if (typeof setUrls !== "undefined") {
			this.#urlMin = setUrls;
			this.#urlMobile = setUrls;
			this.#urlOrigin = setUrls;
			this.#urlWeb = setUrls;
		}
		return {
			urlMin: this.#urlMin,
			urlMobile: this.#urlMobile,
			urlOrigin: this.#urlOrigin,
			urlWeb: this.#urlWeb,
		};
	}

	urlMin(setUrlMin) {
		if (typeof setUrlMin !== "undefined") this.#urlMin = setUrlMin;
		return this.#urlMin;
	}

	urlMobile(setUrlMobile) {
		if (typeof setUrlMobile !== "undefined")
			this.#urlMobile = setUrlMobile;
		return this.#urlMobile;
	}

	urlOrigin(setUrlOrigin) {
		if (typeof setUrlOrigin !== "undefined")
			this.#urlOrigin = setUrlOrigin;
		return this.#urlOrigin;
	}

	urlWeb(setUrlWeb) {
		if (typeof setUrlWeb !== "undefined") this.#urlWeb = setUrlWeb;
		return this.#urlWeb;
	}

	isTargetDoc(setIsTargetDoc) {
		if (typeof setIsTargetDoc !== "undefined")
			this.#isTargetDoc = setIsTargetDoc;
		return this.#isTargetDoc;
	}

	companyId(setCompanyId) {
		if (typeof setCompanyId !== "undefined") this.#companyId = setCompanyId;
		return this.#companyId;
	}

	siteId(setSiteId) {
		if (typeof setSiteId !== "undefined") this.#siteId = setSiteId;
		return this.#siteId;
	}

	employeeId(setEmployeId) {
		if (typeof setEmployeId !== "undefined") this.#employeeId = setEmployeId;
		return this.#employeeId;
	}

	postId(setPostId) {
		if (typeof setPostId !== "undefined") this.#postId = setPostId;
		return this.#postId;
	}

	isNew() {
		return this.#isNew;
	}

	addToDocsUtiles = (setVal) => {
		if (typeof setVal !== "undefined") this.#addToDocsUtiles = setVal;
		return this.#addToDocsUtiles;
	};

	values = (no_temp) => ({
		documentId: no_temp
			? this.#documentId
			: this.#documentId || this.tempId,
		tempId: this.tempId,
		name: this.#name,
		docTypeId: this.#docTypeId,
		publishedDate: this.#publishedDate,
		lastChanged: this.#lastChanged,
		lastChangeAuthorId: this.#lastChangeAuthorId,
		documentRes: this.#documentRes,
		viewCount: this.#viewCount,
		urlMin: this.#urlMin,
		urlMobile: this.#urlMobile,
		urlOrigin: this.#urlOrigin,
		urlWeb: this.#urlWeb,
		isTargetDoc: this.#isTargetDoc,
		isShareable: this.#isShareable,
		fileDocString: this.#fileDocString,
		companyId: this.#companyId,
		siteId: this.#siteId,
		employeeId: this.#employeeId,
		postId: this.#postId,
		isNew: this.#isNew,
		categories: this.#categories,
		addToDocsUtiles: this.#addToDocsUtiles,
	});

	typeof = () => "DocumentObject";
}

export default DocumentObject;
